import axios from 'axios'

// const BASE_URL = 'http://medibot.online:8040'
// const IMAGE_URL = 'http://medibot.online/resources'


const BASE_URL = 'http://medibot.cc/api/'
const IMAGE_URL = 'http://mediot.cc/resources'


export default {
	postRequest: (options) => {
		// 返回一个promise对象
		const url = BASE_URL + options.url
		console.log('postRequest url = ', url)
		const method = options.method || 'GET'
		const data = options.data || {}

		let token = localStorage.getItem('projectToken')
		axios.defaults.headers.common['Authorization'] = token

		return new Promise((resolve, reject) => {
			axios.default.comm
			axios({
					url: url,
					method: method,
					data: data,
				})
				.then((res) => {
					console.log('postRequest success res = ', res)
					resolve(res.data);
				})
				.catch((err) => {
					console.log('postRequest error err = ', err)
					reject(err);
				});
		});
	}
}
